module.exports = __webpack_public_path__ + "notif-archive-icon.png?750bd303a8608b340eaa9592390735ab";